/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getLegacyEntry = /* GraphQL */ `
  query GetLegacyEntry($id: ID!) {
    getLegacyEntry(id: $id) {
      id
      userId
      title
      content
      type
      photoPath
      voiceConversationId
      packId
      promptId
      writerVersion
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const listLegacyEntries = /* GraphQL */ `
  query ListLegacyEntries(
    $filter: ModelLegacyEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLegacyEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        title
        content
        type
        photoPath
        voiceConversationId
        packId
        promptId
        writerVersion
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShareableMedia = /* GraphQL */ `
  query GetShareableMedia($id: ID!) {
    getShareableMedia(id: $id) {
      id
      shareId
      storyId
      userId
      mediaType
      s3Key
      title
      storytellerName
      photoS3Key
      sourceType
      createdAt
      owner
      updatedAt
      __typename
    }
  }
`;
export const listShareableMedias = /* GraphQL */ `
  query ListShareableMedias(
    $filter: ModelShareableMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShareableMedias(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        shareId
        storyId
        userId
        mediaType
        s3Key
        title
        storytellerName
        photoS3Key
        sourceType
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shareableMediaByShareId = /* GraphQL */ `
  query ShareableMediaByShareId(
    $shareId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelShareableMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shareableMediaByShareId(
      shareId: $shareId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shareId
        storyId
        userId
        mediaType
        s3Key
        title
        storytellerName
        photoS3Key
        sourceType
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shareableMediaByUserId = /* GraphQL */ `
  query ShareableMediaByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelShareableMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shareableMediaByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shareId
        storyId
        userId
        mediaType
        s3Key
        title
        storytellerName
        photoS3Key
        sourceType
        createdAt
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserData = /* GraphQL */ `
  query GetUserData($id: ID!) {
    getUserData(id: $id) {
      id
      userId
      recipients
      shares
      capsules
      accountSettings
      legacyBook
      collections
      journal
      memoryCareSubjects
      celebrationBooks
      lastUpdated
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUserData = /* GraphQL */ `
  query ListUserData(
    $filter: ModelUserDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        recipients
        shares
        capsules
        accountSettings
        legacyBook
        collections
        journal
        memoryCareSubjects
        celebrationBooks
        lastUpdated
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userDataByUserId = /* GraphQL */ `
  query UserDataByUserId(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userDataByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        recipients
        shares
        capsules
        accountSettings
        legacyBook
        collections
        journal
        memoryCareSubjects
        celebrationBooks
        lastUpdated
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStoryDraft = /* GraphQL */ `
  query GetStoryDraft($id: ID!) {
    getStoryDraft(id: $id) {
      id
      userId
      title
      wholeTitle
      wholeContent
      flickTitle
      flickContent
      activeVersion
      promptId
      promptText
      packId
      bookId
      occasion
      voiceConversationId
      polishTier
      landingPlayedAt
      transcript
      owner
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStoryDrafts = /* GraphQL */ `
  query ListStoryDrafts(
    $filter: ModelStoryDraftFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStoryDrafts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        title
        wholeTitle
        wholeContent
        flickTitle
        flickContent
        activeVersion
        promptId
        promptText
        packId
        bookId
        occasion
        voiceConversationId
        polishTier
        landingPlayedAt
        transcript
        owner
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
